'use strict';

class CXGrayImagePixelMutableArray {
    constructor () {
        this._pixelsArray = [];
    }

    addPixel (pos) {
        this._pixelsArray.push(new Uint32Array([pos, 0]));
    }

    addPixelwithValue (pos, value) {
        this._pixelsArray.push(new Uint32Array([pos, value]));
    }

    count () {
        return this._pixelsArray.length;
    }

    getPixels () {
        return this._pixelsArray;
    }
}
export default CXGrayImagePixelMutableArray;
